export class Parser {
  /**
   * @param number
   * @return {string}
   */
  static toCurrency(number) {
    if (number < 1000) {
      return number.toLocaleString();
    } else if (number >= 1000 && number < 1000000) {
      return (number / 1000).toString().match(/^-?\d+(?:\.\d{0,1})?/)[0] + "K";
      // return (+(number/1000).toFixed(1)).toLocaleString() + 'K';
      // return (Math.floor(+(number / 1000))).toLocaleString() + 'K';
    } else if (number >= 1000000) {
      // return Math.round((number/1000000 + Number.EPSILON) * 10) / 10 + 'M';
      // return (Math.floor(+(number / 1000))).toLocaleString() + 'K';
      return (
        (number / 1000000).toString().match(/^-?\d+(?:\.\d{0,3})?/)[0] + "M"
      );
      // return (+(number / 1000000).toFixed(2)).toLocaleString() + 'M';
    } else {
      return number.toLocaleString();
    }
  }
  // static toCurrency(number) {
  //     if (number >= 1000000) {
  //         return (Math.floor(+(number / 1000))).toLocaleString() + 'K';
  //     } else
  //         return number.toLocaleString();
  // }

  static convertToXLetters(text, x) {
    if (!text) return "".padStart(x, " ");
    if (text.length === x) return text;
    else if (text.length > x) return `${text.slice(0, x - 2)}..`;
    else if (text.length < x) {
      const padding = x - text.length;
      let textToReturn = "";
      const padStartMaxLength = +(padding / 2).toFixed() + text.length;
      textToReturn = text.padStart(padStartMaxLength, " ");
      textToReturn = textToReturn.padEnd(x, " ");
      return textToReturn;
    }
  }

  /* convert To X Letters Padding Left 0

     */
  static convertToXLettersPL0(text, x) {
    if (text.length === x) return text;
    else if (text.length > x) return `${text.slice(0, x - 2)}..`;
    else if (text.length < x) {
      // const padding = x - text.length;
      // let textToReturn = "";
      // const padStartMaxLength = +(padding / 2).toFixed() + text.length
      // textToReturn = text.padStart(padStartMaxLength, ' ');
      text = text.padEnd(x, " ");
      return text;
    }
  }

  static decodeAmount(parsedAmount) {
    if (parsedAmount.indexOf("K") > -1) {
      return 1000 * +parsedAmount.replace("K", "");
    } else if (parsedAmount.indexOf("M") > -1) {
      return 1000000 * +parsedAmount.replace("M", "");
    } else {
      return +parsedAmount;
    }
  }
}
